import { laravelAxios } from '../../../../config/axios/laravelAxios';

async function getContactIdCrm(contact) {
  const getContactIdCrm = await laravelAxios.get(`crm/getContact/${contact}`);
  return getContactIdCrm;
}
export default getContactIdCrm;
